module.exports = __webpack_public_path__ + "img/slide15_vn.7d4b2bb0.jpg";